<template>
  <el-card>
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">Linked Devices</span>
      <span class="ring-card__header-buttons">
        <RefreshButton @click.native="fetchLinkedDevices" />
      </span>
    </div>
    <div
        v-loading="loading"
        class="card-content">
      <el-table
          :data="data"
          stripe
          style="width: 100%">
        <el-table-column
            prop="description"
            label="Description" />
        <el-table-column
            prop="kind"
            label="Type" />
        <el-table-column
            width="180"
            label="Call Alerts">
          <template slot-scope="scope">
            <el-switch
                v-if="!scope.row.kind.includes('cam')"
                v-model="scope.row['call_alerts']"
                disabled="true" />
          </template>
        </el-table-column>
        <el-table-column
            width="180"
            label="Motion Alerts">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row['motion_alerts']"
                disabled="true" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import axios from "axios";
import { startCase, get } from "lodash";
import RefreshButton from "@/containers/Customer/RefreshButton";

export default {
  name: "LinkedDevices",
  components: { RefreshButton },
  props: {
    chimeId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      data: [],
      loading: false,
    };
  },
  computed: {},
  created() {
    this.fetchLinkedDevices();
  },
  methods: {
    startCase: startCase,
    fetchLinkedDevices() {
      this.loading = true;
      axios
        .get(`/v2/links/${this.chimeId}/linked_doorbots`)
        .then((response) => {
          this.data = get(response, "data.linked_doorbots", []);
        })
        .catch((err) => {
          this.$message({
            message: "Something went wrong!",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
